var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    width: "24px",
    viewBox: "0 0 401.81 401.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.42,0L0,311.42l90.38,90.39L401.81,90.38,311.42,0ZM28.43,311.42L311.42,28.43l61.96,61.96-33.77,33.77-30.98-30.98-14.21,14.21,30.98,30.98-37.49,37.49-38.75-38.74-14.21,14.21,38.75,38.74-37.5,37.5-30.98-30.98-14.21,14.21,30.98,30.98-37.5,37.5-38.74-38.74-14.21,14.21,38.74,38.74-34.71,34.71-30.98-30.98-14.21,14.21,30.98,30.98-30.97,30.97-61.96-61.96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculation);
export default __webpack_public_path__ + "static/media/calculation.8166d5d33745af3f35f0659bbf1db5f0.svg";
export { ForwardRef as ReactComponent };